<template>
  <div>
    <div
      class="text-h6 text-sm-h4 my-4 d-flex justify-space-between align-center"
    >
      Новости
    </div>
    <object-grid-advanced
      :value="news"
      title="Новости"
      :field-defs="[
        { text: 'Заголовок', value: 'title', width: '50%' },
        { text: 'Дата создания', value: 'createdAtDisplay', width: '50%' },
      ]"
      :show-actions="{
        edit: true,
        delete: false,
      }"
      @doEditItem="openNews"
      instance-id="manager_newsSearch"
    />
    <v-dialog
      v-if="selectedNews"
      v-model="showNewsModal"
      :value="showNewsModal"
      :width="600"
      content-class="rounded-xl ma-2 ma-sm-6"
      persistent
    >
      <news-modal :news="selectedNews" @ok="closeNewsModal" />
    </v-dialog>
    <error-message-wrapper ref="error_wrapper" />
  </div>
</template>

<script>
import ObjectGridAdvanced from "@/components/ObjectGridAdvanced.vue";
import ErrorMessageWrapper from "@/components/ErrorMessageWrapper.vue";
import NewsModal from "@/components/NewsModal.vue";
import NSApi from "@/api/NSApi";

export default {
  name: "ManagerNewsView",
  components: { ObjectGridAdvanced, ErrorMessageWrapper, NewsModal },
  data() {
    return {
      news: [],
      unreadQueue: [],
      showNewsModal: false,
      selectedNews: null,
    };
  },
  methods: {
    async loadNews() {
      try {
        const newsData = await NSApi.instance.getNews({ scope: "internal" });
        this.news = newsData.map((item) => {
          const dateField = item.createdAt || item.created_at;
          let dateStr = "";
          if (dateField) {
            try {
              const date = new Date(dateField);
              if (!isNaN(date.getTime())) {
                dateStr = date.toLocaleDateString("ru-RU", {
                  year: "numeric",
                  month: "2-digit",
                  day: "2-digit",
                  hour: "2-digit",
                  minute: "2-digit",
                });
              } else {
                dateStr = dateField;
              }
            } catch (e) {
              dateStr = dateField || "";
            }
          }
          return {
            ...item,
            activeDisplay: item.active ? "Да" : "Нет",
            createdAtDisplay: dateStr,
          };
        });
        const viewedIds = await NSApi.instance.getViewedNewsIds();
        this.unreadQueue = this.news.filter((n) => !viewedIds.includes(n.id));
        this.showNextUnread();
      } catch (error) {
        console.error("Error loading news:", error);
        if (this.$refs.error_wrapper) {
          this.$refs.error_wrapper.showError(error);
        }
      }
    },
    async showNextUnread() {
      if (this.unreadQueue.length === 0) return;
      const next = this.unreadQueue.shift();
      try {
        const newsData = await NSApi.instance.getNewsById(next.id);
        this.selectedNews = newsData;
        this.showNewsModal = true;
      } catch (error) {
        console.error("Error loading news item:", error);
      }
    },
    async openNews(newsItem) {
      try {
        const newsData = await NSApi.instance.getNewsById(newsItem.id);
        this.selectedNews = newsData;
        this.showNewsModal = true;
      } catch (error) {
        console.error("Error loading news item:", error);
        if (this.$refs.error_wrapper) {
          this.$refs.error_wrapper.showError(error);
        }
      }
    },
    async closeNewsModal(viewedId) {
      if (viewedId != null) {
        try {
          await NSApi.instance.markNewsViewed(viewedId);
        } catch (error) {
          console.error("Error marking news as viewed:", error);
        }
      }
      this.showNewsModal = false;
      this.selectedNews = null;
      this.showNextUnread();
    },
  },
  mounted() {
    this.loadNews();
  },
};
</script>

<style scoped></style>
